// @ts-check
import React from 'react';
import PropTypes from 'prop-types';
import { InjectedFormProps } from 'redux-form'; // eslint-disable-line no-unused-vars
import { reduxForm } from 'utils/reduxFormWrapper';
import { customRequired } from 'utils/validation';
import HForm, {
  TextField,
  PhoneMaskField,
  TextAreaField,
  RadioGroupField,
  Last4SSNMaskField,
} from 'shared/containers/portal_layout/HForm';
import Errors from 'shared/components/Errors';
import SpinnerButton from 'shared/components/SpinnerButton';

/* eslint-disable no-unused-vars */
import {
  Referral,
  ReferralProfile,
  ReferralConfirmationFormType,
} from './types';
/* eslint-enable no-unused-vars */

const primaryPhoneRequired = customRequired("Primary phone can't be blank");
const outOfGroupReasonRequired = customRequired(
  'A reason to send the referral out of group is required'
);

/** @typedef {{
  referral: Referral,
  referralProfile: ReferralProfile,
  loyaltyPrompt: boolean
} & InjectedFormProps<ReferralConfirmationFormType> } ReferralConfirmationFormPropsType */

/** @type { React.ValidationMap<ReferralConfirmationFormPropsType> } */
const propTypes = {
  referral: PropTypes.object.isRequired,
  referralProfile: PropTypes.object.isRequired,
  loyaltyPrompt: PropTypes.bool.isRequired,
  handleSubmit: PropTypes.func.isRequired,
  error: PropTypes.object,
  submitting: PropTypes.bool.isRequired,
};

/** @type { React.FC<ReferralConfirmationFormPropsType> } */
const ReferralConfirmationForm = ({
  referral,
  referralProfile,
  loyaltyPrompt,
  collectLast4Ssn,
  handleSubmit,
  error,
  submitting,
}) => {
  return (
    <HForm onSubmit={handleSubmit}>
      <Errors errors={error || []} />
      {!referral.id && <TextField name="patientEmail" label="Patient Email" />}
      <PhoneMaskField
        name="formattedPrimaryPhone"
        label="Patient Primary Phone*"
        required={true}
        validate={primaryPhoneRequired}
      />
      <PhoneMaskField
        name="formattedSecondaryPhone"
        label="Patient Secondary Phone"
      />
      <RadioGroupField
        name="consentToTextMessage"
        label="Does the patient consent to receiving care-related (SMS) text messages?"
        options={[
          { value: true, label: 'Yes' },
          { value: false, label: 'No' },
        ]}
      />
      {collectLast4Ssn ? (
        <Last4SSNMaskField name="last4Ssn" label="Last 4 of SSN" />
      ) : null}
      <TextAreaField name="additionalInfo" label="Additional Notes" />
      {loyaltyPrompt && (
        <TextAreaField
          name="outOfGroupReason"
          label="Out of Network Reason"
          validate={outOfGroupReasonRequired}
        />
      )}

      <div className="form-actions">
        <SpinnerButton
          type="submit"
          className="btn btn-primary btn-large"
          loading={submitting}
        >
          Finish
        </SpinnerButton>
      </div>
    </HForm>
  );
};

ReferralConfirmationForm.displayName = 'ReferralConfirmationForm';
ReferralConfirmationForm.propTypes = propTypes;

export default reduxForm({})(ReferralConfirmationForm);
